import { EVENT_CONFIRMATION_MODAL_OPEN } from '@/config/events'

const Confirmation = {
  install(Vue) {
    Vue.prototype.$confirm = (label, buttonLabels, title, severity) => {
      return new Promise((resolve, reject) => {
        Vue.prototype.$EventBus.$emit(EVENT_CONFIRMATION_MODAL_OPEN, {
          label,
          buttonLabels,
          title,
          severity,
          resolve,
          reject,
        })
      })
    }
  },
}

export default Confirmation
